import {AfterViewInit, Component, HostListener, Inject, Input, OnDestroy, OnInit, PLATFORM_ID,} from '@angular/core';
import {Observable, Subscription} from 'rxjs';
import {
  CmsFlexComponentData
} from '../order-confirmation/order-confirmation-list-item/order-confirmation-order-item.model';
import {CmsComponentData} from '@spartacus/storefront';
import {JsonService} from '@dcp/configurator';
import {isPlatformBrowser} from '@angular/common';
import {CountrySelectorService} from '@app/services/country-selector.service';
import {DcpSupportFormService} from '@app/shared/support-form/dcp-support-form.service';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';

export const SUPPORT_WIDGET_COMPONENT_CMS_ID: string = 'SupportWidgetComponent';

/**
 * External function need to be executed to make chat works
 * after page reloading.
 */
declare const chatWidget: () => void | undefined;

export class SupportWidgetCmsData {
  url: SupportUrl;
  chatAllowedCountries: string[];
}

export class SupportUrl {
  link: string;
  title: string;
}

@UntilDestroy()
@Component({
  selector: 'dcp-checkout-support-widget',
  templateUrl: './checkout-support-widget.component.html',
  styleUrls: ['./checkout-support-widget.component.scss']
})
export class CheckoutSupportWidgetComponent implements OnInit, OnDestroy, AfterViewInit {
  public componentData$: Observable<CmsFlexComponentData>;
  @Input() componentData: SupportWidgetCmsData;
  public componentDataSubscription: Subscription = Subscription.EMPTY;
  isSupportWidgetOpen: boolean = false;

  constructor(
    @Inject(PLATFORM_ID) public platformId: string,
    private cmsData: CmsComponentData<CmsFlexComponentData>,
    private jsonService: JsonService,
    private countrySelectorService: CountrySelectorService,
    private dcpSupportFormService: DcpSupportFormService
  ) {
  }

  ngOnInit() {
    if (!this.componentData) {
      this.mapComponentData();
    }
  }

  get contactUsUrl(): SupportUrl {
    return this.componentData.url;
  }

  get chatAllowedCountries(): string[] {
    if (this.componentData?.chatAllowedCountries) {
      return this.componentData.chatAllowedCountries;
    }
    return [];
  }

  shouldShowChat(): boolean {
    return this.chatAllowedCountries.includes(this.countrySelectorService.getCurrentCountry().isocode);
  }

  ngAfterViewInit() {
    try {
      chatWidget();
    } catch (e) {
    }
  }

  @HostListener('document:mouseup', ['$event.target'])
  @HostListener('document:keydown.escape', ['$event.target'])
  sendCloseEvent(target: HTMLElement): void {
    if (this.isSupportWidgetOpen) {
      const supportWidgetElement = document.querySelector('.support-widget');
      if (supportWidgetElement && supportWidgetElement.contains(target)) {
        return;
      }
      this.isSupportWidgetOpen = false;
    }
  }

  ngOnDestroy(): void {
    this.componentDataSubscription.unsubscribe();
  }

  openSupportRequestModal(): void {
    this.dcpSupportFormService.open();
    this.isSupportWidgetOpen = false;
  }

  /**
   * Function need to be executed to open chat r
   * from external script
   *
   */
  openChat(): void {
    // @ts-ignore
    if (isPlatformBrowser(this.platformId) && window.cvc) {
      // @ts-ignore
      window.cvc.setVisible(true);
      // @ts-ignore
      window.cvc.startChat();
    }
  }

  mapComponentData() {
    this.componentData$ = this.cmsData.data$;
    this.componentDataSubscription = this.componentData$.pipe(untilDestroyed(this)).subscribe(data => {
      this.componentData =
        this.jsonService.parseSafely(data?.classificationsProductData) as SupportWidgetCmsData;
    });
  }

  toggleSupportWidget() {
    this.isSupportWidgetOpen = !this.isSupportWidgetOpen;
  }

}
